import React from 'react';

const InvoiceTable = ({ items, onItemsChange, updatePaymentSummary, onRemoveItem }) => {
  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    onItemsChange(newItems);
  };

  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
      <table className="min-w-full divide-y divide-gray-200 table-fixed invoice-table">
        <thead className="bg-gray-100">
          <tr>
            <th scope="col" className="px-6 py-3 text-left font-bold text-gray-600 uppercase tracking-wider description-cell">
              Description
            </th>
            <th scope="col" className="px-6 py-3 text-right font-bold text-gray-600 uppercase tracking-wider quantity-cell">
              Quantity
            </th>
            <th scope="col" className="px-6 py-3 text-right font-bold text-gray-600 uppercase tracking-wider unit-price-cell">
              Unit Price
            </th>
            <th scope="col" className="px-6 py-3 text-right font-bold text-gray-600 uppercase tracking-wider total-cell">
              Total
            </th>
            <th scope="col" className="px-6 py-3 text-right font-bold text-gray-600 uppercase tracking-wider action-cell action-column">
              Action
            </th>
          </tr>
        </thead>
        <tbody id="invoice-items" className="bg-white divide-y divide-gray-200">
          {items.map((item, index) => (
            <tr className="table-row-input" key={index}>
              <td className="px-6 py-4">
                <input
                  type="text"
                  value={item.description}
                  onChange={(e) => handleItemChange(index, 'description', e.target.value)}
                />
              </td>
              <td className="px-6 py-4">
                <input
                  type="number"
                  min="0"
                  value={item.quantity}
                  onChange={(e) => handleItemChange(index, 'quantity', parseFloat(e.target.value) || 0)}
                  onBlur={updatePaymentSummary} // Recalculate on blur
                  className="w-24 text-right quantity"
                />
              </td>
              <td className="px-6 py-4">
                <input
                  type="number"
                  min="0"
                  value={item.unitPrice}
                  onChange={(e) => handleItemChange(index, 'unitPrice', parseFloat(e.target.value) || 0)}
                  onBlur={updatePaymentSummary} // Recalculate on blur
                  className="w-24 text-right unit-price"
                />
              </td>
              <td className="px-6 py-4 text-right total-cell">$<span className="total-amount">{(item.quantity * item.unitPrice).toFixed(2)}</span></td>
              <td className="px-6 py-4 text-right action-column">
                <button
                  onClick={() => onRemoveItem(index)}
                  className="remove-button text-red-500 hover:text-red-700 font-bold py-1 px-2 rounded-full bg-red-100 hover:bg-red-200 transition duration-150 ease-in-out"
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;